export default "../images/interactive-map.jpg";